import { Card, CardContent, Chip, Stack, Typography } from '@mui/material'
import React from 'react'
import { useReaderContext } from '../../../Contexts/Modules/ReaderModule/ReaderModule'
import { Clear, Done } from '@mui/icons-material'
import StepHeader from './StepHeader'
import { stackGap } from '../../../Constants&Theme/Spacing'

function Step2Select() {
  const { vesselSelectionModel, containerSelectionModel } = useReaderContext()
  return (
    <Card
      variant="outlined"
      sx={{ flex: 1 }}
    >
      <CardContent sx={{ height: 1, display: 'flex', flexDirection: 'column' }}>
        <StepHeader
          step={2}
          name={'Select'}
        />
        <Stack gap={stackGap.col}>
          <Typography variant="body2">
            Select the items you wish to modify from the table below
          </Typography>
          <Stack
            gap={1 / 2}
            sx={{ mt: 'auto' }}
          >
            <Chip
              icon={containerSelectionModel.length > 0 ? <Done /> : <Clear />}
              label={`${containerSelectionModel.length} containers`}
              color={containerSelectionModel.length > 0 ? 'success' : 'error'}
              variant="outlined"
            />
            <Chip
              icon={vesselSelectionModel.length > 0 ? <Done /> : <Clear />}
              label={`${vesselSelectionModel.length} vessels`}
              color={vesselSelectionModel.length > 0 ? 'success' : 'error'}
              variant="outlined"
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default Step2Select
